import React, { FC } from 'react'
import './index.scss'

interface IProps {
  data: any;
}

const PointSquare: FC<IProps> = (props: IProps) => {
  const { data } = props
  return (
    <div className='point-square-list'>
      {[...Array(9)].map((item: any, index: number) => {
        return (
          <div
            className='point-block '
            key={index}
          >
            {index < data.collectPointTarget && (
              <div
                className='point-item'
                style={{
                  backgroundImage:
                    index < data.points
                      ? `Url(${data.extra?.iconEnable || '/resources/images/collectPoint/cup.png'})`
                      : `Url(${data.extra?.iconDisable || '/resources/images/collectPoint/cup-disable.png'})`,
                }}
                key={index}
              >
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}

export default PointSquare
